import * as React from 'react'
import createSvgIcon from '../createSvgIcon'

export default createSvgIcon(
  <path d='M5.71815 4.16003L4.5 5.37818L10.7018 11.58L4.63857 17.6433L5.85672 18.8614L11.92 12.7982L18.1433 19.0215L19.3614 17.8033L13.1381 11.58L19.5 5.21815L18.2818 4L11.92 10.3619L5.71815 4.16003Z' />,
  'Close'
)
